import { Col, Row } from 'antd';
import { AppProps } from 'presentation/App';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { useEffect, useState } from 'react';
import { TabComponent } from './components/TabComponents';

const CU01202Page = (props: AppProps) => {
    const [roomInfo, setRoomInfo]: [any, any] = useState(null);
    const dispatch = useAppDispatch();
    const [listAttachments, setListAttachments] = useState([]);
    const [isInit, setIsInit] = useState(true);

    useEffect(() => {
        initChat();
    }, []);

    useEffect(() => {
        if (roomInfo) {
            getListAttachmentFiles();
        }
    }, [roomInfo]);

    const initChat = async () => {
        dispatch(startFetching());
        try {
            const roomResponse = await load_connected_chat_room();
            if (roomResponse.success) {
                setRoomInfo(roomResponse.data);
            }
        } catch (err) {
            dispatch(completeFetching());
        }
    };

    const load_connected_chat_room = async () => {
        return props.chatUseCase.getChatRoom();
    };

    const getListAttachmentFiles = async () => {
        try {
            const data = {
                chatRoomId: roomInfo?.chatRoomId,
            };
            const response = await props.chatUseCase.getAttachmentFile(data);
            const listFiles = response?.data ?? [];
            setListAttachments(listFiles.reverse());
        } catch (error) {
            console.log(error);
        } finally {
            setIsInit(false);
            dispatch(completeFetching());
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-012-02-container"
        >
            <PageTitle title={'ファイル一覧'} />
            <section className="center-inside w-full">
                <div className="center-item h-auto w-full md:w-full">
                    <Row className="tabs-container" wrap>
                        {listAttachments.length > 0
                            ? listAttachments.map((element: any, index: number) => (
                                  <Col
                                      key={index}
                                      span={12}
                                      style={{ minWidth: '278px' }}
                                      className={`column ${index % 2 == 0 ? 'pr-0 2xl:pr-[40px]' : 'pl-0 2xl:pl-[40px]'}`}
                                      onClick={() => window.open(element.fileUrl)}
                                  >
                                      <TabComponent title={element?.fileName} />
                                  </Col>
                              ))
                            : !isInit && (
                                  <div
                                      style={{
                                          width: '100%',
                                          textAlign: 'center',
                                      }}
                                  >
                                      データはありません
                                  </div>
                              )}
                    </Row>
                </div>
            </section>
        </div>
    );
};

export default CU01202Page;
